import { JSX } from "react";

export const Cross = (): JSX.Element => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="2.16285"
                height="16.2214"
                rx="1.08143"
                transform="matrix(0.707119 -0.707095 -0.707119 -0.707095 11.4727 12.999)"
                fill="#0B090A"
            />
            <rect
                width="2.16285"
                height="16.2214"
                rx="1.08143"
                transform="matrix(0.707119 0.707095 0.707119 -0.707095 0 11.4702)"
                fill="#0B090A"
            />
        </svg>
    );
};
